import React from 'react';
import PropTypes from 'prop-types';

import { contentSvgs } from 'assets/icons';

import * as S from './styles';

const ProjectLine = ({ projects, paginationIndex }) => (
  <>
    {projects.map(item => {
      const {
        nome,
        identificacao,
        id_projeto: idProjeto,
        status_projeto: statusProjeto,
        nome_categoria_projeto: categoriaProjeto,
        id_cliente: idCliente,
        id_acc_manager: idAccManager,
      } = item;

      return (
        <S.ProjectContainer key={idProjeto}>
          <S.ProjectContent>
            <S.ProjectItems>
              <S.Item>
                <span>Nome do projeto</span>
                {nome}
              </S.Item>
              <S.Item>
                <span>Identificação</span>
                {identificacao}
              </S.Item>
              <S.Item>
                <span>Categoria</span>
                {categoriaProjeto}
              </S.Item>
              <S.Item>
                <span>Status</span>
                {statusProjeto}
              </S.Item>
            </S.ProjectItems>
            <S.ProjectMore>
              {contentSvgs('moreInfos')}
              <S.MoreActions>
                <S.MoreActionsHeader>Ações</S.MoreActionsHeader>
                <S.MoreActionsItem
                  to={{
                    pathname: '/auth/coordinate-projects/manage-project',
                    state: { ...item, paginationIndex },
                  }}
                >
                  Editar projeto
                </S.MoreActionsItem>
                <S.MoreActionsItem
                  to={{
                    pathname: '/auth/coordinate-projects/add-sales',
                    state: {
                      idProjeto,
                      nome,
                      identificacao,
                      idCliente,
                      idAccManager,
                      index: paginationIndex,
                    },
                  }}
                >
                  Gerenciar vendas
                </S.MoreActionsItem>
              </S.MoreActions>
            </S.ProjectMore>
          </S.ProjectContent>
        </S.ProjectContainer>
      );
    })}
  </>
);

export default ProjectLine;

ProjectLine.propTypes = {
  projects: PropTypes.arrayOf(
    PropTypes.shape(PropTypes.oneOfType([PropTypes.string, PropTypes.number])),
  ).isRequired,
  paginationIndex: PropTypes.number.isRequired,
};
